import React, { useState, useEffect, useRef } from "react";
import "./Whatsapp.css";
import whatsImg from "../../assets/imgs/whatsapp.svg";
import tCrossImg from "../../assets/imgs/tCross.svg";

function Whatsapp() {
  const [isOpen, setIsOpen] = useState(false);
  const popupRef = useRef(null);

  const whatsappLink = "https://wa.me/9710933555";

  const openWhatsapp = () => {
    window.open(whatsappLink, "_blank", "noopener,noreferrer");
  };

  useEffect(() => {
    const handler = (e) => {
      if (popupRef.current && !popupRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("click", handler);
    return () => document.removeEventListener("click", handler);
  }, []);

  return (
    <div className="floWhatsp">

      {isOpen && (
        <div className="hdWrp" ref={popupRef}>

          <button
            type="button"
            className="whatsappTextBtn"
            onClick={openWhatsapp}
          >
            Chat on WhatsApp
          </button>

  
          <button
            type="button"
            className="close"
            onClick={() => setIsOpen(false)}
            aria-label="Close WhatsApp popup"
          >
            <img src={tCrossImg} alt="Close" />
          </button>
        </div>
      )}

  
      <button
        type="button"
        className="whImWrp"
        aria-label="Open WhatsApp chat"
        onClick={() => {
          if (window.innerWidth > 768) {
            setIsOpen((prev) => !prev);
          } else {
            openWhatsapp();
          }
        }}
        onMouseEnter={() => {
          if (window.innerWidth > 768) {
            setIsOpen(true);
          }
        }}
      >
        <img src={whatsImg} alt="WhatsApp icon" />
      </button>
    </div>
  );
}

export default Whatsapp;
